import type { AuthProviderProps } from "react-oidc-context";

const KEYCLOAK_URL = import.meta.env.VITE_KEYCLOAK_URL ?? "https://auth.sf-devs.kaptioapis.com";
const KEYCLOAK_REALM = import.meta.env.VITE_KEYCLOAK_REALM ?? "kaptio";
const KEYCLOAK_CLIENT_ID = import.meta.env.VITE_KEYCLOAK_CLIENT_ID ?? "kira-admin";

export const oidcConfig: AuthProviderProps = {
  authority: `${KEYCLOAK_URL}/realms/${KEYCLOAK_REALM}`,
  client_id: KEYCLOAK_CLIENT_ID,
  redirect_uri: window.location.origin,
  post_logout_redirect_uri: window.location.origin,
  scope: "openid profile email",
  automaticSilentRenew: true,
  onSigninCallback: () => {
    window.history.replaceState({}, document.title, window.location.pathname);
  },
};
